<div class="comment-item" [class.top-level]="isTopLevel" [class.reply]="!isTopLevel" [class.first-level-reply]="isFirstLevelReply">
  <div class="comment-header">
    <div class="user-info">
      <div class="avatar">
        <img [src]="comment.authorAvatarUrl || 'assets/profile_image.png'" [alt]="comment.authorName" class="user-avatar" />
      </div>
      <div class="user-details">
        <div class="name-and-role">
          <span class="author-name">{{ comment.authorName }}</span>
          <span class="user-role">{{ comment.authorRole }}</span>
        </div>
      </div>
    </div>

    <div class="timestamp">
      {{ comment.updatedAt || comment.createdAt | folioCardTimeAgo }}
    </div>
  </div>

  <div class="comment-content">
    <div class="comment-bubble">
      <div class="comment-text" *ngIf="!comment.isEditing">
        {{ comment.content }}
      </div>

      <div class="comment-edit" *ngIf="comment.isEditing">
        <ptl-comment-input
          [momentId]="momentId"
          [placeholder]="'translations.comments.actions.editComment' | transloco"
          [initialValue]="comment.content"
          [isEditMode]="true"
          (commentUpdated)="onEditSaved($event)"
          (editCancelled)="cancelEdit()"
        >
        </ptl-comment-input>
      </div>
    </div>
  </div>

  <div class="comment-actions-bar">
    <div class="action-buttons">
      <button mat-button class="like-btn" [class.liked]="comment.likes.liked" (click)="onLikeToggle()" [disabled]="isLoading">
        <mat-icon>favorite</mat-icon>
        <span>{{ 'translations.global.button.like' | transloco }}</span>
      </button>

      <button mat-button class="reply-btn" (click)="startReply()" [disabled]="comment.isReplying">
        <mat-icon>chat_bubble_outline</mat-icon>
        <span>{{ 'translations.global.button.reply' | transloco }}</span>
      </button>

      <button mat-button class="edit-btn" (click)="startEdit()" *ngIf="isCurrentUserAuthor" [disabled]="comment.isEditing">
        <mat-icon>edit</mat-icon>
        <span>{{ 'translations.global.button.edit' | transloco }}</span>
      </button>

      <button mat-button class="delete-btn" (click)="onDelete()" *ngIf="isCurrentUserAuthor" [disabled]="isLoading">
        <mat-icon>delete</mat-icon>
        <span>{{ 'translations.global.button.delete' | transloco }}</span>
      </button>
    </div>

    <div class="like-section">
      <button
        mat-button
        class="likes-count-btn"
        *ngIf="comment.likes.totalLikes > 0"
        (click)="showLikesDialog($event)"
        [attr.aria-label]="'translations.comments.actions.likesCount' | transloco: { count: comment.likes.totalLikes }"
      >
        <mat-icon>favorite</mat-icon>
        <span class="likes-count">{{ comment.likes.totalLikes }}</span>
      </button>
    </div>
  </div>

  <div class="reply-input" *ngIf="comment.isReplying">
    <ptl-comment-input
      [momentId]="momentId"
      [placeholder]="'translations.comments.actions.replyTo' | transloco: { author: comment.authorName }"
      [parentCommentId]="comment.id"
      (commentCreated)="onReplyCreated($event)"
    >
    </ptl-comment-input>
  </div>

  <div class="replies-section" *ngIf="comment.repliesCount > 0">
    <button mat-button class="expand-replies-btn" (click)="toggleReplies()" [class.expanded]="comment.isExpanded">
      <mat-icon>{{ comment.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      <span>
        {{
          comment.isExpanded
            ? ('translations.comments.actions.collapseReplies' | transloco: { count: comment.repliesCount })
            : ('translations.comments.actions.expandReplies' | transloco: { count: comment.repliesCount })
        }}
      </span>
    </button>

    <div class="replies-list" *ngIf="comment.isExpanded && comment.replies && comment.replies.length > 0">
      <div class="reply-item-wrapper" *ngFor="let reply of comment.replies; trackBy: trackByCommentId">
        <ptl-comment-item
          [comment]="reply"
          [momentId]="momentId"
          [isTopLevel]="false"
          [currentUserId]="currentUserId"
          [isFirstLevelReply]="isTopLevel"
          (commentUpdated)="commentUpdated.emit($event)"
          (commentDeleted)="commentDeleted.emit($event)"
          (commentLiked)="commentLiked.emit($event)"
          (replyCreated)="replyCreated.emit($event)"
        >
        </ptl-comment-item>
      </div>

      <div class="show-more-replies" *ngIf="hasMoreReplies">
        <button mat-button class="show-more-replies-btn" (click)="loadMoreReplies()" [disabled]="isLoadingReplies">
          <mat-icon>expand_more</mat-icon>
          <span>{{ 'translations.comments.actions.showMoreReplies' | transloco }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
